import {
  Button,
  Layout,
  Modal,
  notification,
  Skeleton,
  theme,
  Typography,
} from "antd";
import React, { useContext, useRef, useState } from "react";
import {
  initInterpreteSlice,
  setPropertiesInterprete,
  updateInterprete,
} from "../Slices/InterpreteSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { Dropdown } from "antd";
import routes from "../../../engine/routes";
import {
  diplomas,
  languagesList,
  levels,
  modeInterpretariat,
  roles,
} from "../../../utils/constants";
import {
  ActionRoleSpecific,
  onlyRoleMapping,
  userHasLevel,
} from "../../../engine/AuthRoute";
import { countryList } from "../../../utils/listsLabels";
import { UserContext } from "../../../engine/context/User.context";
import dayjs from "../../../utils/dayjs";
import { http } from "../../../engine/api/http";
import { DownOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { ActionDropdown } from "../../../shared/components/ActionDropdown/ActionDropdown";
import { HiOutlineMail } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { AiFillCalendar } from "react-icons/ai";
import { FaExternalLinkAlt } from "react-icons/fa";
import { t } from "i18next";
import { CiMail } from "react-icons/ci";
import { RiMailSendLine } from "react-icons/ri";
import { customers } from "../../../engine/customerConfig";
import { DurationHourChecker } from "../../Prestations/PrestationDetail/DurationHourChecker";
import { CheckNumeroInterprete } from "./CheckNumeroInterprete";
import { TomTomMaps } from "../../../shared/components/CustomForm/TomTomMaps/TomTomMaps";
import {TbFileTypePdf, TbFileTypeXml} from "react-icons/tb";
import {
  createXMLWages,
  downloadStringFileXml_CSV,
  jsonToCsv,
} from "../../../utils/bills.xml";
import useDocumentCreator from "../../../engine/hooks/useDocumentCreator";

const { Content, Sider, Header, Footer } = Layout;

export function InterpreteDetail({ unitId, expanded, onClose }) {
  const { t } = useTranslation();
  const { id } = useParams();
  const { interprete, loading } = useSelector(state => state.interprete);

  const { configuration } = useContext(UserContext);

  const { user } = useContext(UserContext);

  const { init, clear } = initInterpreteSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [ready, setReady] = useState(false);

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const [selectedMonth, setSelectedMonth] = useState(() => {
    // Récupérer le mois actuel (getMonth() retourne 0 pour janvier, 1 pour février, etc.)
    const currentMonth = new Date().getMonth() + 1; // Conversion en base 1
    // Si le mois actuel est janvier (1), le mois précédent est décembre (12), sinon on soustrait 1.
    const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
    // Retourner le mois précédent sous forme de chaîne à deux chiffres
    return String(previousMonth).padStart(2, "0");
  });

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const {
    info: {
      firstname,
      lastname,
      genre,
      etatCivil,
      phone,
      nationality,
      country,
      birthday,
      children,
    },
    status,
    interpreteData: {
      urgentListAllowed = false,
      abacusId,
      iban,
      bankingName,
      bankingHead,
      contractStartDate = null,
      avs = "",
      institutionsToAvoid,
      dateWeddingDivorce = null,
      lastDateFormation,
      partnerIndemnity,
      sharedFolder = "",
      addressStart,
      address,
      licence,
      taxeSource,
      nLoga = "",
      languages,
      number,
      expirationDateLicence,
      lastDateControl,
    },
    comment,
    email,
    subRoles,
  } = interprete;

  const [showModal, setShowModal] = useState(false);

  const inputs = [
    {
      parentLabel: t("InterpreteDetail.informations"),
      children: [
        {
          label: t("InterpreteDetail.lastname"),
          name: "info.lastname",
          value: lastname,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: t("InterpreteDetail.firstname"),
          name: "info.firstname",
          value: firstname,
          required: true,
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.interpreteNumber"),
          name: "interpreteData.abacusId",
          value: abacusId,
          placeholder: t("InterpreteDetail.interpreteNumberAbacus"),
          type: "number",
          precision: 0,
          min: 0,
          visible: userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
        {
          label: t("InterpreteDetail.interpreteNumbernLoga"),
          name: "interpreteData.nLoga",
          value: nLoga,
          placeholder: t("InterpreteDetail.interpreteNumbernLoga"),
          type: "input",
          visible: userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
        {
          col: 24,
          type: "component",
          name: "CheckNumeroInterprete",
          noWrapper: true,
          component: ({ refForm }) => <CheckNumeroInterprete />,
        },
        {
          label: t("InterpreteDetail.genre"),
          name: "info.genre",
          placeholder: t("InterpreteDetail.genre"),
          value: genre ? genre : undefined,
          required: true,
          type: "select",
          selectContent: [
            { label: t("InterpreteDetail.male"), value: "male" },
            { label: t("InterpreteDetail.female"), value: "female" },
          ],
          col: 24,
        },
        {
          label: t("InterpreteDetail.etatCivil"),
          name: "info.etatCivil",
          placeholder: t("InterpreteDetail.etatCivil"),
          value: etatCivil,
          // required: true,
          type: "select",
          selectContent: [
            { label: t("InterpreteDetail.single"), value: "single" },
            { label: t("InterpreteDetail.married"), value: "married" },
            { label: t("InterpreteDetail.divorced"), value: "divorced" },
            { label: t("InterpreteDetail.widowed"), value: "widowed" },
            {
              label: t("InterpreteDetail.registeredPartnership"),
              value: "registeredPartnership",
            },
            {
              label: t("InterpreteDetail.dissolvedPartnership"),
              value: "dissolvedPartnership",
            },
          ],
          col: 24,
        },
        {
          name: "interpreteData.dateWeddingDivorce",
          label: t("InterpreteDetail.dateWeddingDivorce"),
          value: dateWeddingDivorce ? dayjs(dateWeddingDivorce) : null,
          col: 24,
          type: "date",
        },
        {
          label: t("InterpreteDetail.email"),
          name: "email",
          normalize: value => value && value.toLowerCase(),
          value: email,
          type: "email",
          col: 24,
        },
        {
          label: t("InterpreteDetail.phone"),
          name: "info.phone",
          value: phone,
          addonBefore: <PhoneOutlined />,
          type: "input",
          col: 24,
        },

        {
          required: true,
          label: t("InterpreteDetail.addressStart"),
          name: "interpreteData.addressStart",
          value: addressStart,
          type: "google-adress",
          col: 24,
        },
        {
          col: 24,
          type: "component",
          name: "mapstomtom",
          noWrapper: true,
          component: ({ refForm }) => (
            <TomTomMaps
              keys={"interpreteData.addressStart"}
              refForm={refForm}
            />
          ),
        },

        {
          label: t("InterpreteDetail.comment"),
          name: "comment",
          value: comment,
          visible: userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          type: "textarea",
          col: 24,
        },
        {
          addonBefore: <FaExternalLinkAlt />,
          label: t("InterpreteDetail.shared"),
          name: "interpreteData.sharedFolder",
          visible:
            userHasLevel({
              not: {
                [roles.interprete]: "r", //
              },
            }) && configuration?.interprete?.hasInputSharedFolder,
          value: sharedFolder,
          type: "input-link",
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("InterpreteDetail.linguistique"),
      children: [
        {
          label: t("InterpreteDetail.languages"),
          name: "interpreteData.languages",
          value: languages,
          multiple: true,
          showSearch: true,
          type: "select",
          selectContent: languagesList().sort((a, b) =>
            a?.label?.localeCompare(b.label),
          ),
          col: 24,
        },
        {
          label: t("InterpreteDetail.interpretingMode"),
          required: true,
          name: "interpreteData.interpretingMode",
          type: "checkbox",
          value: interprete.interpreteData.interpretingMode,
          checkboxs: modeInterpretariat(),
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("InterpreteDetail.trainings"),
      children: [
        {
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          label: t("InterpreteDetail.trainings"),
          name: "interpreteData.formations",
          type: "input",
          capitalize: false,
          col: 24,
        },
        {
          label: t("InterpreteDetail.diplomas"),
          name: "interpreteData.diplomas",
          type: "radios",
          radios: diplomas(),
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
        {
          label: t("InterpreteDetail.level"),
          name: "interpreteData.level",
          type: "radios",
          visible:
            configuration?.interprete?.hasLevel === false
              ? userHasLevel({
                  only: {
                    [roles.admin]: "crud", //
                    [roles.permanance]: "crud", //
                  },
                })
              : true,
          radios: levels(),
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
        process.env.CUSTOMER_ID === customers.oseoavic
          ? {
              label: t("InterpreteDetail.lastTrainingDate"),
              name: "interpreteData.lastDateFormation",
              value: lastDateFormation ? dayjs(lastDateFormation) : null,
              type: "date",
              allowClear: true,
              showTime: false,
              disabled: !userHasLevel({
                not: {
                  [roles.interprete]: "r", //
                },
              }),
              col: 24,
            }
          : null,
      ],
    },
    {
      parentLabel: t("InterpreteDetail.admin"),
      children: [
        {
          label: t("InterpreteDetail.nationality"),
          name: "info.nationality",
          value: nationality,
          placeholder: t("InterpreteDetail.nationality"),
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.country"),
          name: "info.country",
          value: country,
          placeholder: t("InterpreteDetail.country"),
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.birthday"),
          name: "info.birthday",
          value: birthday ? dayjs(birthday) : null,
          placeholder: t("InterpreteDetail.birthday"),
          type: "date",
          col: 24,
        },
        {
          label: t("InterpreteDetail.avs"),
          name: "interpreteData.avs",
          value: avs,
          placeholder: t("InterpreteDetail.avs"),
          type: "input",
          col: 24,
        },

        {
          label: t("InterpreteDetail.partnerIndemnity"),
          name: "interpreteData.partnerIndemnity",
          value: partnerIndemnity,
          placeholder: t("InterpreteDetail.partnerIndemnity"),
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.licence"),
          name: "interpreteData.licence",
          value: licence,
          placeholder: t("InterpreteDetail.licence"),
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.taxeSource"),
          name: "interpreteData.taxeSource",
          value: taxeSource,
          placeholder: t("InterpreteDetail.taxeSource"),
          type: "checkbox-bool",
          col: 24,
        },
        {
          label: t("InterpreteDetail.expirationDateLicence"),
          name: "interpreteData.expirationDateLicence",
          allowClear: true,
          value: expirationDateLicence ? dayjs(expirationDateLicence) : null,
          placeholder: t("InterpreteDetail.expirationDateLicence"),
          type: "date",
          col: 24,
        },
        {
          label: t("InterpreteDetail.children"),
          name: "info.children",
          value: children,
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.authorisation"),
          name: "interpreteData.urgentListAllowed",
          type: "checkbox-bool",
          value: urgentListAllowed,
          col: 24,
        },
        {
          label: t("InterpreteDetail.contractStartDate"),
          name: "interpreteData.contractStartDate",
          type: "date",
          value: contractStartDate ? dayjs(contractStartDate) : null,
          col: 24,
        },
        {
          label: t("InterpreteDetail.iban"),
          name: "interpreteData.iban",
          type: "input",
          value: iban,
          col: 24,
        },
        {
          label: t("InterpreteDetail.bankingName"),
          name: "interpreteData.bankingName",
          type: "input",
          value: bankingName,
          col: 24,
        },
        {
          label: t("InterpreteDetail.bankingHead"),
          name: "interpreteData.bankingHead",
          type: "input",
          value: bankingHead,
          col: 24,
        },
      ],
    },
    {
      parentLabel: userHasLevel({
        not: {
          [roles.interprete]: "r", //
        },
      })
        ? t("InterpreteDetail.actions")
        : "",
      children: [
        loading !== true
          ? {
              label: t("InterpreteDetail.avoidClients"),
              name: "interpreteData.institutionsToAvoid",
              type: "dynamic-select",
              value: institutionsToAvoid,
              visible: userHasLevel({
                not: {
                  [roles.interprete]: "r", //
                },
              }),
              endPoint: "institutions",
              multiple: true,
              itemsCallBack: (institutions, form) => {
                try {
                  setReady(true);
                  formRef.current.setFieldValue(
                    "interpreteData.institutionsToAvoid",
                    institutionsToAvoid,
                  );
                } catch (e) {
                  console.log(e);
                }
              },
              itemCallback: item => {
                return {
                  key: item._id,
                  label: `${item.name}`,
                  value: item._id,
                };
              },
              col: 24,
            }
          : null,
        id !== "new"
          ? {
              label: t("InterpreteDetail.accessAuthorized"),
              name: "status",
              value: status,
              required: true,
              visible: userHasLevel({
                not: {
                  [roles.interprete]: "r", //
                },
              }),
              type: "select",
              selectContent: [
                { label: t("active"), value: "active" },
                { label: t("inactive"), value: "inactive" },
                { label: t("archived"), value: "archived" },
              ],
              col: 24,
            }
          : null,
      ],
    },
    {
      children: [
        {
          label:
            id === "new"
              ? t("InterpreteDetail.createInterprete")
              : t("InterpreteDetail.save"),
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];

  const { i18n } = useTranslation();

  const formatString = s => {
    return Number(s.replace(/[^0-9.-]+/g, ""));
  };
  const onSubmitForm = async data => {
    if (id === "new") {
      data.role = roles.interprete;
    }
    await dispatch(setPropertiesInterprete(data));
    dispatch(updateInterprete());
  };

  const sendEmail = async () => {
    let caller = await http.post("/notifications/invitation", { userId: id });
    caller.status === 200 &&
      notification.success({
        message: t("InterpreteDetail.emailSentSuccessfully"),
      });
  };
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingExport, setLoading] = useState(false);
  const [get, createAndGet, isLoading, setUrl, doc] = useDocumentCreator();

  const exportWages = async () => {
    try {
      setLoading(true);

      // setShowModal(!showModal);

      const data = formRef.current.getFieldsValue(true);

      const loggit = await http.post("/logs", {
        baseUrl: "/api/users-pdf",
        action: "export",
        route: "/api/users/wages-pdf",
        ressource: "/api/users/wages-pdf",
        content: {
          interpreteIds: [id],
          ...data,
        },
      });

      const getPdf = () => {
        createAndGet(
          { interpretes: [id], ...data, language: i18n.language },
          `bills/wages-pdf`,
          true,
          true,
          () => {
            setLoading(false);
          },
          true,
          i18n.language === "fr"
            ? `salaire_${data.month}_${data.year}`
            : `stipendio_${data.month}_${data.year}`,
        );
      };

      getPdf();
    } catch (e) {
      console.log(e);
    }
  };

  const yearslabelsArray = () => {
    // add each year since 2023 and the current year by date
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 2023; i <= currentYear; i++) {
      years.push({ value: i, label: i });
    }
    return years;
  };

  const isInterprete = userHasLevel({
    only: {
      [roles.interprete]: "crud",
    },
  });

  const inputsModalDates = [
    {
      parentLabel: "",
      children: [
        {
          name: "year",
          label: t("InterpretesList.modal.year"),
          required: true,
          type: "select",
          value: selectedYear,
          col: 24,
          selectContent: yearslabelsArray(),
          onChange: ({ value }, b) => {
            setSelectedYear(value);
          },
        },
        {
          name: "month",
          col: 24,
          label: t("InterpretesList.modal.month"),
          type: "select",
          value: selectedMonth,
          required: true,
          onChange: ({ value }, b) => {
            setSelectedMonth(value);
          },

          selectContent: (() => {
            const currentYear = new Date().getFullYear();
            const currentMonthInt = new Date().getMonth() + 1; // mois courant en entier (1-12)
            const months = [
              { value: "01", label: t("InterpretesList.modal.january") },
              { value: "02", label: t("InterpretesList.modal.february") },
              { value: "03", label: t("InterpretesList.modal.march") },
              { value: "04", label: t("InterpretesList.modal.april") },
              { value: "05", label: t("InterpretesList.modal.may") },
              { value: "06", label: t("InterpretesList.modal.june") },
              { value: "07", label: t("InterpretesList.modal.july") },
              { value: "08", label: t("InterpretesList.modal.august") },
              { value: "09", label: t("InterpretesList.modal.september") },
              { value: "10", label: t("InterpretesList.modal.october") },
              { value: "11", label: t("InterpretesList.modal.november") },
              { value: "12", label: t("InterpretesList.modal.december") },
            ];

            // Si l'utilisateur est un interprète et que l'année sélectionnée est l'année en cours,
            // désactive les mois correspondant au mois en cours et aux mois futurs.
            if (isInterprete && selectedYear === currentYear) {
              return months.map(m => ({
                ...m,
                disabled: parseInt(m.value, 10) >= currentMonthInt,
              }));
            }

            // Pour les autres cas (année passée ou utilisateur non interprète), aucune désactivation n'est appliquée.
            return months;
          })(),
        },
      ],
    },
  ];

  return (
    <>
      <Typography.Title level={3} className={""}>
        {id === user._id
          ? t("InterpreteDetail.myInterpreteAccount")
          : routes.interpretes(id).detail.title}
      </Typography.Title>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <ActionDropdown
            rule={{
              only: {
                [roles.admin]: "crud",
                [roles.permanance]: "crud",
                [roles.interprete]: "crud",
              },
            }}
          >
            {onlyRoleMapping([roles.admin, roles.permanance]) ? (
              <a onClick={sendEmail}>
                <span style={{ marginLeft: 5, marginRight: 10 }}>
                  <RiMailSendLine size={18} />
                </span>
                {t("InterpreteDetail.sendInvitationEmail")}
              </a>
            ) : null}

            {onlyRoleMapping([roles.admin, roles.permanance, roles.interprete]) ? (
              <a
                onClick={() => setShowModal(!showModal)}
                disabled={loadingExport}
                loading={loadingExport}
              >
                <span style={{ marginLeft: 5, marginRight: 10 }}>
                  <TbFileTypePdf size={18} />
                </span>
                {t("InterpretesList.other.exportSalary")}
              </a>
            ) : null}
          </ActionDropdown>

          <CustomForm
            disabled={
              !userHasLevel({
                only: {
                  [roles.admin]: "crud", //
                  [roles.permanance]: "crud", //
                },
              })
            }
            initialValues={interprete}
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />

          <Modal
            open={showModal}
            title={t("InterpretesList.modal.selectPeriodOnly")}
            okText={t("InterpretesList.modal.exportSalaries")}
            onOk={exportWages}
            loading={true}
            okButtonProps={{ loading: loadingExport }}
            onCancel={() => setShowModal(!showModal)}
          >
            <CustomForm
              dataSource={inputsModalDates}
              refForm={formRef}
              style={{
                flex: 1,
                maxWidth: 1200,
                paddingRight: 20,
              }}
              labelCol={24}
              wrapperCol={24}
            />
          </Modal>
        </>
      )}
    </>
  );
}
